import { addItemToBasket, BASKET_TYPES, extendFormToMap } from 'containers/OrderDetails/basketSlice'
import { getPlaceDetails, selectPlaceData, selectPlaceId, selectPlaceStatus } from './placeSlice'
import AvailabilityNotificationPopup from './popups/AvailabilityNotificationPopup'
import { useLocation, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import useTranslation from 'hooks/useTranslation'
import DetailsPopup from './popups/DetailsPopup'
import DetailsLocation from './DetailsLocation'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import { useEffect, useState } from 'react'
import htbox1 from 'assets/img/htbox1.png'
import htbox2 from 'assets/img/htbox2.png'
import { STATUS } from 'utils/constants'
import MagElement from './MagElement'
import Error from 'components/Error'
import { v7 } from 'uuid'
import './style.scss'

const MapDetails = () => {
  const [userSelectedDifferentHash, selectDifferentHashByUser] = useState(false)
  const [isDimensions, setDimensions] = useState(false)
  const [sizeArray, setSizeArray] = useState([])
  const [size, setSize] = useState({
    hash: '',
    index: 0,
  })

  const { search, state } = useLocation()
  const placeId = useSelector(selectPlaceId)
  const status = useSelector(selectPlaceStatus)
  const { warehouses, sizes, ...place } = useSelector(selectPlaceData)
  const { placeId: placeIdParams } = useParams()
  const { popup, openPopup } = usePopupState()

  const { push, replace } = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation('mapDetails')

  const succeed = status === STATUS.succeed

  useEffect(() => {
    dispatch(getPlaceDetails(placeIdParams))
  }, [placeIdParams, dispatch])

  useEffect(() => {
    const isUnlocked = (state && typeof state === 'object' && 'unlock' in state) ? state.unlock : undefined
    if (isUnlocked) {
      replace(window.location.pathname + window.location.search)
    }
  }, [replace, state])

  useEffect(() => {
    const query = new URLSearchParams(search)
    const warehouseTypeId = query.get('warehouseTypeId')

    if (warehouseTypeId) setSize({
      hash: warehouseTypeId,
      index: -1
    })
  }, [search])

  useEffect(() => {
    if (warehouses && placeId === placeIdParams) {
      const keys = Object.entries(warehouses)
        .sort((a, b) => {
          const getSize = (v) => {
            const firstKey = Object.keys(v)[0]
            return v[firstKey]?.data?.capacity || 0
          }
          return getSize(a[1]) - getSize(b[1])
        })
        .map(([k]) => k)
      setSizeArray(keys)
    }
  }, [warehouses, placeId, placeIdParams])

  useEffect(() => {
    if (!size.hash && sizeArray[0]) setSize({
      hash: sizeArray[0],
      index: 0
    })
    else if (size.index === -1 && sizeArray.length > 0) {
      const newIdx = sizeArray.findIndex(e => e === size.hash)
      if (newIdx > -1) setSize({
        ...size,
        index: newIdx
      })
      else {
        selectDifferentHashByUser(true)
        setSize({
          hash: sizeArray[0],
          index: 0
        })
      }
    }
  }, [size, sizeArray])

  const changeHash = (toBigger = true) => {
    const newIdx = size.index + (toBigger ? 1 : -1)
    if (sizeArray[newIdx]) setSize({
      hash: sizeArray[newIdx],
      index: newIdx
    })
  }

  return (
    <div className='placeResult'>
      {popup?.type === 'details' && <DetailsPopup
        count={popup.body?.count}
        data={popup.body?.details}
      />}
      {popup?.type === 'availability' && <AvailabilityNotificationPopup
        placeId={placeIdParams}
        companyName={place.companyName}
        groupHash={popup.body?.groupHash}
        variantHash={popup.body?.variantHash}
        name={popup.body?.name}
      />}

      <div className='placeResult__location'>
        <DetailsLocation succeed={succeed} />
      </div>

      {status === STATUS.failed
        ? <Error />
        : <section className='--animated'>
          {((succeed && warehouses[size.hash]) || status === STATUS.pending) && <>
            <div className='placeResult__mag'>
              <div className='placeResult__mag__title'>
                <h2>{sizes?.[size.index]?.name}</h2>
                <span></span>
                <h2>{sizes?.[size.index]?.size} m<sup>2</sup></h2>
              </div>

              <div className='placeResult__mag__graphics'>
                <div
                  className='mag__marker'
                  onClick={() => succeed && size.index > 0 && changeHash(false)}
                  style={size.index === 0 ? { opacity: '0.5' } : {}}>

                  <div className='marker'>
                    <i className='icon icon--chevron-left' />
                  </div>
                  <span>{t('smaller')}</span>
                </div>

                {succeed && (
                  <div className='mag__img'>
                    <img
                      alt='warehouse'
                      src={isDimensions
                        ? (sizes[size.index]?.renders?.transparent || htbox2)
                        : (sizes[size.index]?.renders?.default || htbox1)
                      }
                      style={userSelectedDifferentHash ? { opacity: 0.5 } : undefined}
                    />
                    {userSelectedDifferentHash && <div className='svg__title'>{t('inaccessible')}</div>}
                  </div>
                )}

                <div
                  className='mag__marker'
                  onClick={() => succeed && size.index < sizeArray.length - 1 && changeHash()}
                  style={(!succeed || size.index === sizeArray.length - 1) ? { opacity: '0.5' } : undefined}>
                  <div className='marker'>
                    <i className='icon icon--chevron-right' />
                  </div>
                  <span>{t('bigger')}</span>
                </div>

              </div>

              <div className='placeResult__mag__buttons'>
                <span className={isDimensions ? undefined : 'active'} onClick={() => setDimensions(false)}>{t('availableWarehouses')}</span>
                <span className={isDimensions ? 'active' : undefined} onClick={() => setDimensions(true)}>{t('whatCanYouFitHere')}</span>
              </div>
            </div>
            {isDimensions
              ? (({ internalHeight, internalLength, internalWidth, doorHeight, doorWidth, fits }) => {
                return <div className='placeResult__sizes'>
                  <div className='placeResult__sizes__item'>
                    <h3>{t('internalDimensions-shorter')}:</h3>
                    <span>{t('width-shorter')}: {internalWidth}m x {t('height-shorter')}: {internalHeight}m x {t('length-shorter')}: {internalLength}m</span>
                  </div>
                  <div className='placeResult__sizes__item'>
                    <h3>{t('doorDimensions')}:</h3>
                    <span>{t('width-shorter')}: {doorWidth}m x {t('height-shorter')}: {doorHeight}m</span>
                  </div>
                  <h4>{t('whatCanYouFitHere')}</h4>
                  <div className='placeResult__sizes__list'>
                    {fits?.map(({ name }, idx) => <div
                      key={idx}
                      className='placeResult__sizes__list__item'>
                      <div className='iconWrap'>
                        <i className='icon icon--check'></i>
                      </div>
                      <span>{name}</span>
                    </div>)}
                  </div>
                </div>
              })(sizes[size.index] || {})
              : (<div className='placeResult__magList'>
                {succeed
                  ? Object.entries(warehouses[size.hash])
                    .sort(([, a], [, b]) => a.order - b.order)
                    .map(([hash, data]) => (
                      <MagElement
                        key={hash}
                        data={data}
                        openPopup={(type) => {
                          if (type === 'details') {
                            openPopup({ type: 'details', body: { details: data?.details, count: data?.free_now_to_rent_count } })
                          } else if (type === 'availability') {
                            openPopup({ type: 'availability', body: { name: `${data?.warehouseTypeName} - ${data?.name}`, groupHash: size.hash, variantHash: hash } })
                          }
                        }}
                        action={(date) => {
                          const identifier = v7()
                          const { street, estateNumber, localNumber, city, province, gpslatitude, gpslongitude } = place
                          const { hasOnlineAccess, internalHeight, internalLength, internalWidth, area } = data?.data || {}

                          dispatch(
                            addItemToBasket({
                              hash,
                              identifier,
                              type: BASKET_TYPES.rent,
                              object: data?.data?.object,
                              address: { street, estateNumber, localNumber, city, province, gpslatitude, gpslongitude },
                              minDate: date ? date.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1') : undefined,
                              size: { internalHeight, internalLength, internalWidth, area },
                              name: data.warehouseTypeName,
                              hasOnlineAccess,
                              placeId,
                            })
                          )
                          push(`/order/${identifier}`)
                          dispatch(extendFormToMap(false))
                        }}
                      />
                    ))
                  : [1, 2, 3].map((e) => <MagElement key={e} />)}
              </div>)}
          </>}
        </section>}
    </div>
  )
}

export default MapDetails